export const API_VERSIONS = {
  v1: 'v1',
  v2: 'v2',
};
